// extracted by mini-css-extract-plugin
export default {"dropdown-menu-item":"dd8346"};